import * as CM                                                  from '@emersya/mpa-components-manager';

export class RadioStylizedRenderingMode extends CM.Plugin<
	InputSelectComponent<any, any>
> implements TInputSelectRenderingMode<any, any> {
	id = 'radio-stylized';

	getSlotDOM(component : InputSelectComponent<any, any>) {
		return (component.component_DOM);
	};

	attach(component : InputSelectComponent<any, any>) {
		void component;
	};

	detach(component : InputSelectComponent<any, any>) {
		void component;
	};

	constructor() {
		super();
	};
};
import { InputSelectComponent, TInputSelectRenderingMode } from '../InputSelect';
